export default __webpack_public_path__ + "static/media/techStack.18a6061e.svg";